export default __webpack_public_path__ + "static/media/hero-liquidity-mining.06d7799e.svg";